import { AfterViewInit, Component, OnInit, Renderer2 } from '@angular/core';
import { GlobalComponent } from './global-component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = GlobalComponent.title;
}
